<template>
  <div class="msg-manual-typing">
    <span class="typing-placehold">{{$t('common_typing')}}</span>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.msg-manual-typing {
  padding: 10px 15px;
  font-size: 14px;
  line-height: 20px;

  // 正在输入
  .typing-placehold {
    color: #a8abb3;
  }
}
</style>
